import React, {useState, useEffect} from 'react'
import {Form, Row, Col, Select, Input, Button} from 'antd'
import {toast} from 'react-toastify'
import apiRequest from '../../hooks/ApiRequest'

const {Option} = Select

const InformatonForm = ({form, brokerID, modalVisible, onSuccess}) => {
  const {getFieldDecorator, setFieldsValue, resetFields} = form;
  const [loading, setLoading] = useState(false);
  const loginUserId = localStorage.getItem('loggedInUserID');
  const fetchClaimLimitById = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Policy/GetBrokerDetails?userId=${id}`,
        'GET',
      )
      if (res.success) {
        const data = res.data
        console.log(data);
        
        setFieldsValue({
            addressLine1:  data.addressLine1,
            addressLine2: data.addressLine2,
            firmName: data.firmName,
            city: data.city,
            state:  data.state,
            postalCode: data.postalCode,
            bankName: data.bankName,
            accountNumber: data.accountNumber,
            ifsc: data.ifsc,
            accountHolderName: data.accountHolderName,
            bankAddress: data.bankAddress,
        })
      } else {
        toast.error('Failed to fetch claim limit details')
      }
    } catch (err) {
      toast.error('Error loading claim limit')
    }
  }

  useEffect(() => {
    if (brokerID) {
      fetchClaimLimitById(loginUserId)
    } else {
      resetFields()
    }
  }, [brokerID, modalVisible])

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)
      const payload = {
        id: brokerID || 0,
        userId:loginUserId,
        ...values
      }
      console.log('payload',payload);
      const url = brokerID
        ? `${process.env.REACT_APP_BASE_URL}/Policy/UpdateBrokerDetails/update`
        : `${process.env.REACT_APP_BASE_URL}/Policy/CreateAdditionalBrokerDetails/create`

      try {
        const res = await apiRequest(url, 'POST',payload)
        if (res.success) {
          toast.success(
            brokerID
              ? 'Claim limit updated successfully'
              : 'Claim limit set successfully',
          )
          if (onSuccess) onSuccess()
        } else {
          toast.error(res.message || 'Something went wrong')
        }
      } catch (err) {
        toast.error('Request failed')
      } finally {
        setLoading(false)
      }
    })
  }

  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <h5
        style={{
          color: '#F15A2B',
          fontWeight: '500',
          fontSize: '20px',
          marginBottom: '0',
        }}>
        <strong> Bank Information </strong>
      </h5>
      <Row gutter={16}>
        <Col md={8}>
          <Form.Item label="Bank Name">
            {getFieldDecorator('bankName', {
              rules: [{required: true, message: 'Please input bank name!'}],
            })(<Input placeholder="Enter bank name" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="Account number">
            {getFieldDecorator('accountNumber', {
              rules: [
                {required: true, message: 'Please input account number!'},
              ],
            })(<Input placeholder="Enter account number" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="SWIFT/BIC Code">
            {getFieldDecorator('ifsc', {
              rules: [{required: true, message: 'Please input swift/bic code!'}],
            })(<Input placeholder="Enter swift/bic code" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="Account Holder">
            {getFieldDecorator('accountHolderName', {
              rules: [
                {required: true, message: 'Please input account holder name!'},
              ],
            })(<Input placeholder="Enter account holder name" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="Bank Address">
            {getFieldDecorator('bankAddress', {
              rules: [{required: true, message: 'Please input bank address!'}],
            })(<Input placeholder="Enter bank address" type="text" />)}
          </Form.Item>
        </Col>
      </Row>
      <h5
        style={{
          color: '#F15A2B',
          fontWeight: '500',
          fontSize: '20px',
          marginBottom: '0',
        }}>
        <strong> Office Information </strong>
      </h5>
      <Row gutter={16}>
      <Col md={8}>
          <Form.Item label="Firm Name">
            {getFieldDecorator('firmName', {
              rules: [{required: true, message: 'Please input firm name!'}],
            })(<Input placeholder="Enter firm" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="Address 1">
            {getFieldDecorator('addressLine1', {
              rules: [{required: true, message: 'Please input address1!'}],
            })(<Input placeholder="Enter address1" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="Address 2">
            {getFieldDecorator('addressLine2', {
            //   rules: [{required: true, message: 'Please input address1!'}],
            })(<Input placeholder="Enter address2" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="City">
            {getFieldDecorator('city', {
              rules: [
                {required: true, message: 'Please input city!'},
              ],
            })(<Input placeholder="Enter city" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="State">
            {getFieldDecorator('state', {
              rules: [{required: true, message: 'Please input state!'}],
            })(<Input placeholder="Enter state" type="text" />)}
          </Form.Item>
        </Col>
        <Col md={8}>
          <Form.Item label="Postal Code">
            {getFieldDecorator('postalCode', {
              rules: [
                {required: true, message: 'Please input account postal code!'},
              ],
            })(<Input placeholder="Enter postal codee" type="text" />)}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {brokerID ? 'Update Information' : 'Add Information'}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default Form.create({name: 'additional_information_form'})(InformatonForm)
